function ScriptFormController(
  psaService,
  toasterService,
  $rootScope,
  $scope,
  $uibModal
) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.psaService = psaService;
    ctrl.toasterService = toasterService;
    ctrl.$rootScope = $rootScope;
    ctrl.viewMode = false;

    // Default values for empty script object
    ctrl.script = {
      name: '',
      target: undefined,
      subtarget: 1,
      active: false,
      conditions: [],
      specialConditions: [],
      consequences: [],
      options: {
        minimumTriggerInterval: 60000,
      },
    };

    ctrl.sameOriginTargets = [
      { type: 'Train', value: 'TRAIN' },
      { type: 'EMU', value: 'EMU' },
      { type: 'Car', value: 'CAR' },
    ];

    ctrl.operators = ['and', 'or'];
    ctrl.targets = [
      { type: 'Fleet', value: 'FLEET' },
      { type: 'Train', value: 'TRAIN' },
      { type: 'EMU', value: 'EMU' },
      { type: 'Car', value: 'CAR' },
    ];
    ctrl.currentScript = null;

    // Track the number of "open" condition and consequences blocks
    ctrl.openConditions = 0;
    ctrl.openConsequences = 0;
    ctrl.openSpecialConditions = 0;

    ctrl.newCondition = {
      type: undefined,
      name: undefined,
      eventId: undefined,
      active: undefined,
      location: undefined,
      value: undefined,
      relationToPrevious: undefined,
      group: undefined,
    };

    ctrl.newSpecialCondition = {
      type: undefined,
      name: undefined,
      location: undefined,
      operator: 'greater than',
      value: undefined,
    };

    ctrl.newConsequence = {
      type: undefined,
      text: '',
      items: [],
      eventClass: undefined,
    };
    ctrl.tagTooltip =
      "These apply to the whole script with logical 'AND' operator";
    ctrl.selectExistingScript();
    ctrl.createNewScriptEvent();
  };

  ctrl.addCondition = () => {
    if (ctrl.script.conditions.length > 0) {
      ctrl.newCondition.relationToPrevious = 'and';
    }
    ctrl.script.conditions.push(angular.copy(ctrl.newCondition));
    ctrl.openConditions++;
  };

  ctrl.addSpecialCondition = () => {
    ctrl.script.specialConditions.push(angular.copy(ctrl.newSpecialCondition));
    ctrl.openSpecialConditions++;
  };

  ctrl.addConsequence = () => {
    ctrl.script.consequences.push(angular.copy(ctrl.newConsequence));
    ctrl.openConsequences++;
  };

  // Remove condition from the list
  ctrl.removeCondition = event => {
    ctrl.script.conditions.splice(event.conditionIndex, 1);
    ctrl.openConditions--;
  };

  // Remove condition from the list
  ctrl.removeSpecialCondition = event => {
    ctrl.script.specialConditions.splice(event.conditionIndex, 1);
    ctrl.openSpecialConditions--;
  };

  // Remove consequence from the list
  ctrl.removeConsequence = event => {
    ctrl.script.consequences.splice(event.consequenceIndex, 1);
    ctrl.openConsequences--;
  };

  ctrl.saveCondition = event => {
    // Prevent incorrect default value from overwriting the correct value set in ScriptForm component
    ctrl.script.conditions[event.conditionIndex] = event.newCondition;
    const logicalOperator =
      ctrl.script.conditions[event.conditionIndex].relationToPrevious;
    ctrl.script.conditions[
      event.conditionIndex
    ].relationToPrevious = logicalOperator;
    ctrl.openConditions--;
  };

  ctrl.saveSpecialCondition = event => {
    ctrl.script.specialConditions[event.conditionIndex] =
      event.newSpecialCondition;
    ctrl.openSpecialConditions--;
  };

  ctrl.saveConsequence = event => {
    ctrl.script.consequences[event.consequenceIndex] = event.newConsequence;
    ctrl.openConsequences--;
  };

  ctrl.conditionOpen = event => {
    ctrl.openConditions++;
  };

  ctrl.consequenceOpen = event => {
    ctrl.openConsequences++;
  };

  ctrl.specialConditionOpen = event => {
    ctrl.openSpecialConditions++;
  };

  ctrl.refreshScriptList = function() {
    ctrl.clearForm();
    ctrl.$rootScope.$emit('refreshScriptList');
  };

  ctrl.refreshScriptListEdit = function() {
    ctrl.viewMode = true;
    ctrl.$rootScope.$emit('refreshScriptList');
  };

  ctrl.selectExistingScript = () => {
    let unbind = ctrl.$rootScope.$on('selectScript', function(event, data) {
      if (data.subtarget.length < 3) {
        data.subtarget = parseInt(data.subtarget);
      }
      // Do only if the data has changed, prevents script list spamming
      if (!angular.equals(ctrl.script, data)) {
        ctrl.script = angular.copy(data);
        ctrl.viewMode = true;
        ctrl.currentScript = null;
      }
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.createNewScriptEvent = () => {
    let unbind = ctrl.$rootScope.$on('createScript', function() {
      ctrl.clearForm();
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.currentScript = angular.copy(ctrl.script);
      ctrl.viewMode = false;
    } else {
      // Reapply the current script data if the user makes changes and presses 'Cancel'
      ctrl.script = angular.copy(ctrl.currentScript);
      ctrl.viewMode = true;
    }
  };

  ctrl.removeScript = () => {
    ctrl.psaService.deleteScript(ctrl.script.id).then(
      function(response) {
        ctrl.toasterService.success(
          'toaster.psa-script-event',
          'toaster.psa-edit-script-successful'
        );
        ctrl.refreshScriptList();
      },
      function(e) {
        ctrl.toasterService.error(
          'toaster.psa-script-event',
          'toaster.psa-edit-script-failure'
        );
        console.log(e);
      }
    );
  };

  ctrl.openConfirmationModal = () => {
    const modalInstance = $uibModal.open({
      templateUrl: '/modules/modals/delete-script-confirmation-modal.html',
      controller: 'resetWidgetsModalController',
      resolve: {},
    });

    modalInstance.result.then(
      () => {
        // User pressed 'Yes' in the modal.
        ctrl.removeScript();
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };

  ctrl.setActivationState = () => {
    ctrl.script.created = null;

    if (ctrl.script.active) {
      ctrl.script.active = false;
    } else {
      ctrl.script.active = true;
    }

    ctrl.psaService.editScript(ctrl.script, ctrl.script.id).then(
      function(response) {
        if (ctrl.script.active) {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-script-activate-successful'
          );
        } else {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-script-deactivate-successful'
          );
        }
        ctrl.refreshScriptList();
      },
      function(e) {
        if (ctrl.script.active) {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-script-activate-failure'
          );
        } else {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-script-deactivate-failure'
          );
        }
        console.log(e);
      }
    );
  };

  // Check that the script has at least one condition and one consequence,
  // and that the script doesn't have any open conditions or consequences.
  ctrl.checkValidity = () => {
    return (
      ctrl.openConditions > 0 ||
      ctrl.openConsequences > 0 ||
      ctrl.openSpecialConditions > 0 ||
      ctrl.script.conditions.length === 0 ||
      ctrl.script.consequences.length === 0
    );
  };

  ctrl.checkOpenStates = () => {
    return (
      ctrl.openConditions > 0 ||
      ctrl.openConsequences > 0 ||
      ctrl.openSpecialConditions > 0
    );
  };

  ctrl.onSubmit = () => {
    if (ctrl.script.id) {
      // OLD SCRIPT EDIT
      const creationTime = ctrl.script.created;
      ctrl.script.created = null; // Editing a script fails if created field is filled
      ctrl.psaService.editScript(ctrl.script, ctrl.script.id).then(
        function(response) {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-edit-script-successful'
          );
          ctrl.script.created = creationTime;
          ctrl.currentScript = null;
          ctrl.refreshScriptListEdit();
        },
        function(e) {
          ctrl.toasterService.error(
            'toaster.psa-script-event',
            'toaster.psa-edit-script-failure'
          );
          console.log(e);
        }
      );
    } else {
      // NEW SCRIPT
      ctrl.psaService.addScript(ctrl.script).then(
        function(response) {
          ctrl.toasterService.success(
            'toaster.psa-script-event',
            'toaster.psa-new-script-successful'
          );
          ctrl.refreshScriptList();
        },
        function(e) {
          ctrl.toasterService.error(
            'toaster.psa-script-event',
            'toaster.psa-new-script-failure'
          );
          console.log(e);
        }
      );
    }
  };

  ctrl.clearForm = () => {
    ctrl.viewMode = false;
    ctrl.openConsequences = 0;
    ctrl.openConditions = 0;
    ctrl.openSpecialConditions = 0;
    ctrl.script = {
      name: '',
      target: undefined,
      subtarget: 1,
      active: false,
      conditions: [],
      specialConditions: [],
      consequences: [],
      options: {
        minimumTriggerInterval: 60000,
      },
    };
  };
}

angular
  .module('psa.module')
  .controller('ScriptFormController', ScriptFormController);
